import {
  ArrowLeftIcon,
  CallVideoIcon,
  InfoIcon,
  LockIcon,
  NotesIcon,
  PopupIcon
} from "@fluentui/react-icons-northstar";
import React, { useEffect, useState } from "react";
import {
  FormattedMessage,
  injectIntl,
  WrappedComponentProps,
} from "react-intl";
import { Link } from "react-router-dom";
import LanguageDropdown from "../../GlobalComponents/LanguageDropdown/LanguageDropdown";
import ProductsDropdown from "../../GlobalComponents/ProductsDropdown/ProductsDropdown";
import ApiIcon from "../../Icons/ApiIcon";
import GetStartedIcon from "../../Icons/GetStartedIcon";
import HomeIcon from "../../Icons/HomeIcon";
import IdeasIcon from "../../Icons/IdeasIcon";
import MoreProductsIcon from "../../Icons/MoreProductsIcon";
import NewDocumentIcon from "../../Icons/NewDocumentIcon";
import ReleaseNotesIcon from "../../Icons/ReleaseNotesIcon";
import RoadMapIcon from "../../Icons/RoadMapIcon";
import TrainingWorkshopIcon from "../../Icons/TrainingWorkshopIcon";
import UpdatesIcon from "../../Icons/UpdatesIcon";
import { OptionCategory } from "../../Types/OptionCategory";
import {
  getSelectedProductInformation,
  getSelectedProductName
} from "../../Utilities/Product";
import { getAllQueryParameters, GetQueryParameter } from "../../Utilities/Url";
import cssStyles from "./Product.module.scss";
import SidebarItem from "./SidebarItem";
import AboutS2S from "./pages/AboutS2SContainer/AboutS2S";
import GetStarted from "./pages/GetStarted/GetStarted";
import GiveUsFeedback from "./pages/GiveUsFeedback/GiveUsFeedback";
import MoreProducts from "./pages/MoreProducts/MoreProducts";
import VideoTrainingUser from "./pages/VideoTrainings/VideoTrainingUser";
import VideoTraining from "./pages/VideoTrainings/VideoTrainings";
import Workshop from "./pages/Workshop/Workshop";

export interface IProductContentProps { }

export interface IProductContentState {
  option: OptionCategory;
  menuOpen: boolean;
  role: string;
}

const ProductContent: React.FC<IProductContentProps & WrappedComponentProps> = (
  props
) => {
  const [state, setState] = useState<IProductContentState>({
    option: null,
    menuOpen: false,
    role: GetQueryParameter("role", "admin"),
  });

  // Detect if running inside an iframe
  const [hideNav, setHideNav] = useState(false);
  useEffect(() => {
    setHideNav(window.self !== window.top);
  }, []);

  useEffect(() => {
    console.log("ProductContent:role", state.role);
    const role = GetQueryParameter("role", "admin");
    setState((prevState) => ({
      ...prevState,
      role,
      option: determineInitialOption(role),
    }));
  }, []);

  const determineInitialOption = (role: string): OptionCategory => {
    const categoryLinks =
      role === "admin"
        ? getSelectedProductInformation().categoryLinks
        : getSelectedProductInformation().categoryLinksUser;

    if (role === "admin") {
      // Prioritize "Get Started" if it's available
      if (categoryLinks.getStarted !== false) {
        return OptionCategory.GetStarted;
      } else if (categoryLinks.knowledgeBase) {
        return OptionCategory.KnowledgeBase;
      } else if (categoryLinks.documentation) {
        return OptionCategory.Documentation;
      } else if (categoryLinks.legacyDocumentation) {
      return OptionCategory.LegacyDocumentation;
      } else if (categoryLinks.showVideoTrainings) {
        return OptionCategory.VideoTrainings;
      } else if (categoryLinks.showWorkshop) {
        return OptionCategory.Workshop;
        // } else if (categoryLinks.createTicket) {
        //   return OptionCategory.CreateTicket;
      } else if (categoryLinks.roadmap) {
        return OptionCategory.Roadmap;
      } else if (categoryLinks.ideas) {
        return OptionCategory.Ideas;
      } else if (categoryLinks.updates) {
        return OptionCategory.Updates;
      } else {
        return OptionCategory.GetStarted; // Fallback to GetStarted if nothing else is available
      }
    } else {
      if (categoryLinks.getStarted !== false) {
        return OptionCategory.GetStarted;
      } else if (categoryLinks.showVideoTrainings) {
        return OptionCategory.VideoTrainings;
      } else {
        return OptionCategory.About;
      }
    }
  };

  const getWebsiteIfNotEmpty = (valueThatCanBeEmpty: any, returnValue?: any) => {
    if (valueThatCanBeEmpty) {
      return returnValue?returnValue:valueThatCanBeEmpty;
    } else {
      setState((prevState) => ({
        ...prevState,
        option: OptionCategory.GetStarted,
      }));
    }
  };

  const renderFrame = (option: OptionCategory) => {
    let frameWebsite: string | null = null;
    let component: React.ReactElement | null = null;

    switch (option) {
      case OptionCategory.GetStarted:
        component = <div className={cssStyles.frameContainer}><GetStarted /></div>;
        break;
      case OptionCategory.KnowledgeBase:
        frameWebsite = getWebsiteIfNotEmpty(
          state.role === "admin"
            ? getSelectedProductInformation().categoryLinks.knowledgeBase
            : "",
          getSelectedProductInformation().categoryLinks.knowledgeBase
        );
        break;
      case OptionCategory.Documentation:
        frameWebsite = getWebsiteIfNotEmpty(
          state.role === "admin"
            ? getSelectedProductInformation().categoryLinks.documentation
            : getSelectedProductInformation().categoryLinksUser.documentation
        );
        break;
      case OptionCategory.LegacyDocumentation:
      frameWebsite = getWebsiteIfNotEmpty(
        state.role === "admin"
          ? getSelectedProductInformation().categoryLinks.legacyDocumentation
          : getSelectedProductInformation().categoryLinksUser.legacyDocumentation
      );
      break;
      case OptionCategory.VideoTrainings:
        component =
          state.role === "admin"
            ? getWebsiteIfNotEmpty(
              getSelectedProductInformation().categoryLinks
                .showVideoTrainings,
              <VideoTraining />
            )
            : getWebsiteIfNotEmpty(
              getSelectedProductInformation().categoryLinks
                .showVideoTrainings,
              <VideoTrainingUser />
            );
        break;
      // case OptionCategory.CreateTicket:
      //   frameWebsite = getWebsiteIfNotEmpty(
      //     getSelectedProductInformation().categoryLinks.createTicket,
      //     getSelectedProductInformation().categoryLinks.createTicket
      //   );
      //   break;
      case OptionCategory.Roadmap:
        frameWebsite = getWebsiteIfNotEmpty(
          getSelectedProductInformation().categoryLinks.roadmap
        );
        break;
      case OptionCategory.Ideas:
        frameWebsite = getWebsiteIfNotEmpty(
          getSelectedProductInformation().categoryLinks.ideas
        );
        break;
      case OptionCategory.Updates:
        frameWebsite = getWebsiteIfNotEmpty(
          getSelectedProductInformation().categoryLinks.updates
        );
        break;
      case OptionCategory.MoreProducts:
        component = <MoreProducts />;
        break;
      case OptionCategory.About:
        component = <AboutS2S />;
        break;
      case OptionCategory.GiveUsFeedback:
        component = <GiveUsFeedback productName={getSelectedProductName()} />;
        break;
      case OptionCategory.Workshop:
        component = <div className={cssStyles.frameContainer}><Workshop /></div>;
        break;
      case OptionCategory.TrustCenter:
        frameWebsite = getWebsiteIfNotEmpty(
          getSelectedProductInformation().categoryLinks.updates
        );
        break;
      /*case OptionCategory.Api:
        frameWebsite = `${
          window.location.origin
        }/api/index.html?theme=${GetQueryParameter("theme","light")}`;*/
        case OptionCategory.Api:
          if (getSelectedProductName() === "ExternalUserManager") {
            frameWebsite = "https://externalusermanager.azurefd.net/swagger/index.html";
          } else {
            frameWebsite = `${window.location.origin}/api/index.html?theme=${GetQueryParameter("theme","light")}`;
          }
        break;
      default:
        break;
    }

    return component ? (
      <>{component}</>
    ) : (
      <div className={cssStyles.iFrameStyles}>
        <iframe
          className={cssStyles.iFrameStyles}
          src={frameWebsite ?? ""}
          title="Content"
        />
      </div>
    );
  };

  const renderSidebarItems = () => {
    const { role } = state;
    const settingsItems: React.ReactElement[] = [];
    const informationItems: React.ReactElement[] = [];

    const createSidebarItem = (
      option: OptionCategory,
      icon: React.ReactElement,
      title: string,
      titleTranslationId: string
    ) => (
      <SidebarItem
        key={option}
        isActive={state.option?.localeCompare(option) === 0}
        onClick={() => setState((prevState) => ({ ...prevState, option, menuOpen: false, }))}
        icon={icon}
        title={title}
        titleTranslationId={titleTranslationId}
      />
    );
    if (role === "admin") {
      settingsItems.push(
        createSidebarItem(
          OptionCategory.GetStarted,
          <GetStartedIcon className={cssStyles.icons} />,
          "Get started*",
          "SideBar.Header.GetStarted"
        ),
        // getSelectedProductInformation().categoryLinks.knowledgeBase &&
        //   createSidebarItem(
        //     OptionCategory.KnowledgeBase,
        //     <InfoIcon outline className={cssStyles.icons} />,
        //     "Knowledge base*",
        //     "SideBar.Header.KnowledgeBase"
        //   ),
        // getSelectedProductInformation().categoryLinks.documentation &&
        // createSidebarItem(
        //   OptionCategory.Documentation,
        //   <NewDocumentIcon className={cssStyles.icons} />,
        //   "Documentation*",
        //   "SideBar.Header.Documentation"
        // ),
        getSelectedProductName() === "TeamsManager"
          ? (
              <SidebarItem
                key="Documentation"
                isActive={state.option?.localeCompare("Documentation") === 0}
                onClick={() => window.open("https://tm-helpcenter.solutions2share.com/", "_blank")}
                icon={<NewDocumentIcon className={cssStyles.icons} />}
                title="Documentation*"
                rightIcon={<PopupIcon className={cssStyles.rightIcon} outline size="small" />}
                titleTranslationId="SideBar.Header.Documentation"
              />
            )
          : getSelectedProductName() === "ExternalUserManager"
          ? (
              <SidebarItem
                key="Documentation"
                isActive={state.option?.localeCompare("Documentation") === 0}
                onClick={() => window.open("https://eum-helpcenter.solutions2share.com/", "_blank")}
                icon={<NewDocumentIcon className={cssStyles.icons} />}
                title="Documentation*"
                rightIcon={<PopupIcon className={cssStyles.rightIcon} outline size="small" />}
                titleTranslationId="SideBar.Header.Documentation"
              />
            )
          : (
              getSelectedProductInformation().categoryLinks.legacyDocumentation &&
              createSidebarItem(
                OptionCategory.LegacyDocumentation,
                <NewDocumentIcon className={cssStyles.icons} />,
                "Legacy Documentation*",
                "SideBar.Header.LegacyDocumentation"
              )
            ),
        // getSelectedProductInformation().categoryLinks.showVideoTrainings &&
        //   createSidebarItem(
        //     OptionCategory.VideoTrainings,
        //     <CallVideoIcon outline className={cssStyles.icons} />,
        //     "Video trainings*",
        //     "SideBar.Header.VideoTrainings"
        //   ),
        getSelectedProductInformation().categoryLinks.showWorkshop &&
        createSidebarItem(
          OptionCategory.Workshop,
          <TrainingWorkshopIcon className={cssStyles.icons} />,
          "Training Workshops*",
          "SideBar.Header.Workshop"
        ),
        getSelectedProductInformation().categoryLinks.apiDocs &&
        createSidebarItem(
          OptionCategory.Api,
          <ApiIcon className={cssStyles.icons} />,
          "API*",
          "SideBar.Header.Api"
        ),
        // getSelectedProductInformation().categoryLinks.createTicket &&
        //   createSidebarItem(
        //     OptionCategory.CreateTicket,
        //     <CallIcon outline className={cssStyles.icons} />,
        //     "Create ticket*",
        //     "SideBar.Header.CreateTicket"
        //   )
      );

      informationItems.push(
        getSelectedProductInformation().categoryLinks.roadmap &&
        createSidebarItem(
          OptionCategory.Roadmap,
          <RoadMapIcon className={cssStyles.icons} />,
          "Roadmap*",
          "SideBar.Header.Roadmap"
        ),
        getSelectedProductInformation().categoryLinks.ideas &&
        createSidebarItem(
          OptionCategory.Ideas,
          <IdeasIcon className={cssStyles.icons} />,
          "Ideas*",
          "SideBar.Header.Ideas"
        ),
        getSelectedProductInformation().categoryLinks.updates &&
        createSidebarItem(
          OptionCategory.Updates,
          <UpdatesIcon className={cssStyles.icons} />,
          "Updates*",
          "SideBar.Header.Updates"
        ),
        // createSidebarItem(
        //   OptionCategory.TrustCenter,
        //   <ReleaseNotesIcon className={cssStyles.icons} />,
        //   "Release notes*",
        //   "SideBar.Header.TrustCenter"
        // ),
        createSidebarItem(
          OptionCategory.MoreProducts,
          <MoreProductsIcon className={cssStyles.icons} />,
          "More products*",
          "SideBar.Header.MoreProducts"
        ),
        createSidebarItem(
          OptionCategory.About,
          <HomeIcon className={cssStyles.icons} />,
          "About*",
          "SideBar.Header.About"
        )
      );
    } else {
      settingsItems.push(
        createSidebarItem(
          OptionCategory.GetStarted,
          <GetStartedIcon className={cssStyles.icons} />,
          "Get started*",
          "SideBar.Header.GetStarted"
        ),
      );

      informationItems.push(
        getSelectedProductInformation().categoryLinks.roadmap &&
        createSidebarItem(
          OptionCategory.Roadmap,
          <RoadMapIcon className={cssStyles.icons} />,
          "Roadmap*",
          "SideBar.Header.Roadmap"
        ),
        getSelectedProductInformation().categoryLinks.ideas &&
        createSidebarItem(
          OptionCategory.Ideas,
          <IdeasIcon className={cssStyles.icons} />,
          "Ideas*",
          "SideBar.Header.Ideas"
        ),
        getSelectedProductInformation().categoryLinks.updates &&
        createSidebarItem(
          OptionCategory.Updates,
          <UpdatesIcon className={cssStyles.icons} />,
          "Updates*",
          "SideBar.Header.Updates"
        ),
        createSidebarItem(
          OptionCategory.MoreProducts,
          <MoreProductsIcon className={cssStyles.icons} />,
          "More products*",
          "SideBar.Header.MoreProducts"
        ),
        createSidebarItem(
          OptionCategory.About,
          <HomeIcon className={cssStyles.icons} />,
          "About*",
          "SideBar.Header.About"
        )
      );
    }

    // Filter out null/undefined items
    const filteredSettingsItems = settingsItems.filter(Boolean);
    const filteredInformationItems = informationItems.filter(Boolean);

    return (
      <>
        {filteredSettingsItems.length > 0 && (
          <>
            <label key="Help" className={cssStyles.navHeader}>
              <FormattedMessage
                id="MainTabUser.help"
                defaultMessage="Help*"
              />
            </label>
            {filteredSettingsItems}
          </>
        )}
        {filteredInformationItems.length > 0 && (
          <>
            <label key="Information" className={cssStyles.navHeader}>
              <FormattedMessage
                id="SideBar.Header.Information"
                defaultMessage="Information*"
              />
            </label>
            {filteredInformationItems}
          </>
        )}
      </>
    );
  };

  return (
    <div className={cssStyles.background}>
      {/* <PagesNavBar targetUrl="/Overview" /> */}
      <div className={cssStyles.gridContainer}>
        {/* Hamburger button (input is visually hidden, for accessibility) */}
        <input
          type="checkbox"
          className={cssStyles.MenuButton}
          tabIndex={0}
          id="MenuButton"
          checked={state.menuOpen}
          onChange={() => setState(prev => ({ ...prev, menuOpen: !prev.menuOpen }))}
          aria-label="Open menu"
        />
        <div
          className={`${cssStyles.MenuButtonWrapper} ${state.menuOpen ? cssStyles.menuOpen : ""}`}
          onClick={() => setState(prev => ({ ...prev, menuOpen: !prev.menuOpen }))}
          tabIndex={0}
          role="button"
          aria-pressed={state.menuOpen}
        >
          <div className={cssStyles.MenuButtonLineWrapper}>
            <div className={cssStyles.MenuButtonLine} />
          </div>
        </div>

        {/* Sidebar */}
        <div className={`${cssStyles.gridMenu} ${state.menuOpen ? cssStyles.menuOpen : ""}`}>
          {!hideNav && (
            <div className={cssStyles.backButton}>
              <Link
                replace
                to={{
                  pathname: "/Overview",
                  search: getAllQueryParameters(window.location.href),
                }}
                className={cssStyles.backButtonLink}
              >
                <ArrowLeftIcon />
                <FormattedMessage id="MainTab.Back" defaultMessage="Back" />
              </Link>
            </div>
          )}
          <ul className={cssStyles.navList}>{renderSidebarItems()}</ul>
        </div>

        {/* Main content */}
        <div className={cssStyles.gridMain}>
          {!hideNav && (
            <div className={cssStyles.mainContentHeader}>
              <div className={cssStyles.headerLeft}>
                <div className={cssStyles.HelpTitle}>
                  <FormattedMessage id="MainTab.Help" defaultMessage="Help*" />
                </div>
              </div>
              <div className={cssStyles.dropdownHolder}>
                <ProductsDropdown />
                <LanguageDropdown />
              </div>
            </div>
          )}
          {renderFrame(state.option)}
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default injectIntl(ProductContent);
